type BlueEventType = { event: string; value: string | number };

declare global {
  interface Window {
    blue_q?: BlueEventType[];
  }
}

let lastEventSig = '';

export const bluePush = (eventSignature: string, events: BlueEventType[]) => {
  if (eventSignature === lastEventSig) {
    return;
  }
  lastEventSig = eventSignature;

  window.blue_q = window.blue_q || [];

  events.forEach((event) => window.blue_q!.push(event));
};
